import {MapOptions} from "leaflet";
import * as L from "leaflet";
import * as L1 from "leaflet.markercluster";
import './Control.Layers';

// Workaround for webpack issue
L.Icon.Default.imagePath = '/leaflet/';


export class Maps {

    public _map;

    public _marker;

    constructor(elementId: string, config: MapOptions) {

        // @ts-ignore
        let lat  = config.center ? config.center.lat || 0 : 0;
        // @ts-ignore
        let lng  = config.center ? config.center.lng || 0 : 0;
        let zoom = config.zoom || 5;


        this._map = L.map(elementId).setView([lat, lng], zoom);

        // add layers
        for (let layerId in config.layers) {
            // @ts-ignore
            this.addLayer(config.layers[layerId]);
        }
    }

    getMap() {
        return this._map;
    }

    /**
     *
     * @param layer
     * @param layerId
     */
    addLayer(layer: L.GridLayerOptions) {
        // @ts-ignore
        L.tileLayer(layer.url, {
            minZoom: layer.minZoom ? layer.minZoom : 2,
            maxZoom: layer.maxZoom ? layer.maxZoom : 18,
            // @ts-ignore
            id: layer.id
        }).addTo(this._map);
    }

    addMarkers(markers: []) {
        markers.forEach(marker => this.addMarker(marker));
    }

    addCluster(markers) {
        var markersCluster = new L1.MarkerClusterGroup();

        markers.forEach(marker => {
            var latLng = new L.LatLng(marker.latitude, marker.longitude);
            markersCluster.addLayer(new L.Marker(latLng, {title: marker.name}));
        });
        this._map.addLayer(markersCluster);
    }

    addClusters(clusters: []) {
        Object.keys(clusters).forEach(key => this.addCluster(clusters[key]));
    }


    /**
     * Adds a marker to the map
     * @param m
     * @returns {any}
     */
    addMarker(m) {

        if (m.lat === null) {
            return;
        }

        let marker = L.marker([m.lat, m.lng]).addTo(this._map);

        if (m.popup) {
            marker.bindPopup(m.popup);
            if (m.showPopup) {
                marker.openPopup();
            }
        }

        this._map.setView([m.lat, m.lng]);

        if (m.zoom) {
            this._map.setZoom(m.zoom);
        }

        if (m.title) {
            // @ts-ignore
            marker._icon.title = m.title;
        }

        if (!this._marker) {
            this._marker = marker;
        }

        return marker;
    }

    addInputMarker(latInputId: string, lngInputId: string, zoomInputId: string) {
        const latInput = document.getElementById(latInputId) as HTMLInputElement;
        const lngInput = document.getElementById(lngInputId) as HTMLInputElement;

        if (!latInput || !lngInput) {
            alert('Could not find the inputs to bind the marker to');
            return false;
        }

        let marker = this._marker ? this._marker : this.addMarker({lat: latInput.value, lng: lngInput.value});
        marker.dragging.enable();

        // moving marker updates the input fields
        marker.on('moveend', function (e) {
            latInput.value = e.target.getLatLng().lat;
            lngInput.value = e.target.getLatLng().lng;
        });

        // changing the input fields updates the marker
        latInput.onchange = lngInput.onchange = (e) => {
            if ('' === latInput.value || '' === lngInput.value) {
                this._map.removeLayer(marker);
            } else {
                marker.setLatLng(L.latLng(parseFloat(latInput.value), parseFloat(lngInput.value)));
                this._map.addLayer(marker);
            }
        };
        latInput.dispatchEvent(new Event('change'));

        // clicking the map updates the marker
        this._map.on('click', function(e) {
            latInput.value = e.latlng.lat;
            lngInput.value = e.latlng.lng;
            latInput.dispatchEvent(new Event('change'));
        });
    }
}